import Vue from "Vue";
import ElementUI from "element-ui";
import promise from "es6-promise";
import "element-ui/lib/theme-chalk/index.css";
import "../assets/plugin.js";
import "../assets/css/globel.css";
import "../assets/css/iconfont.css";
import "../assets/css/_util.css";
import "../assets/css/animate.min.css";
import "../assets/globle.js";
// import info from "../assets/js/info";
import filters from "../assets/globle";
import VueI18n from "vue-i18n";
import { pcaa } from "area-data-vue";
import "area-linkage-vue/dist/index.css";
import AreaLinkageVue from "area-linkage-vue";
import VueCropper from "vue-cropper";
import axios from "axios";
import store from "./store.js";
import waterfall from "vue-waterfall2";

promise.polyfill();

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.api;

// axios.defaults.headers.common['Cookie'] = 'ULT=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJkYXRhIjoiMSIsImlzcyI6InNoYXBpLmNsb3RoZXNtYWtlLmNvbS5jbiIsImF1ZCI6InNoYXBpLmNsb3RoZXNtYWtlLmNvbS5jbiIsImlhdCI6MTU4NzM4NzUyMywiZXhwIjoxNjQ3ODY3NTIzfQ.kvDc6vPT0di5QEUmpqFePvCwz1Ev8I3LTsFkBwJA1W4Rln2zvVx2tnRefenP0Jdjp_GB_WmaxGboMapCurbyusddaxmYWsrD-OOAJ5A-ctfu-3bcmTlfi9GrTTnQF6IvY_KOToKI05uD2MNRdZGqPoh6hnljFmncG8xK_zkwB4o;';
axios.interceptors.response.use(
  async function(res) {
    switch (res.data.code) {
      case 1001:
        Vue.prototype.$message.error(res.data.msg);
        window.location.href = "/login.html";
        return Promise.reject(res);
      case 200:
        return res.data;
      default:
        if (res.data.code > 0) {
          Vue.prototype.$message.error(res.data.msg);
          return Promise.reject(res);
        }

        return res;
    }
  },
  function(err) {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = "请求错误(400)";
          break;
        case 401:
          err.message = "未授权，请重新登录(401)";
          break;
        case 403:
          err.message = "您没有权限访问此页面";
          break;
        case 404:
          err.message = "请求出错(404)";
          break;
        case 408:
          err.message = "请求超时(408)";
          break;
        case 500:
          err.message = "服务器错误(500)";
          break;
        case 501:
          err.message = "服务未实现(501)";
          break;
        case 502:
          err.message = "网络错误(502)";
          break;
        case 503:
          err.message = "服务不可用(503)";
          break;
        case 504:
          err.message = "网络超时(504)";
          break;
        case 505:
          err.message = "HTTP版本不受支持(505)";
          break;
        default:
          err.message = "连接出错!";
      }
    } else {
      err.message = "连接服务器失败!";
    }

    Vue.prototype.$message.error(err.message);

    return Promise.reject(err);
  }
);

Vue.config.productionTip = false;
// Vue.prototype.$info = info;
Vue.prototype.$store = store;
Vue.use(waterfall);
Vue.prototype.$http = axios;
Vue.use(VueI18n);
Vue.use(AreaLinkageVue);
Vue.use(VueCropper);
Vue.prototype.$pcaa = pcaa;
Vue.use(ElementUI);
Vue.directive("throttle", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      el.style.pointerEvents = "none";
      if (!el.disabled) {
        setTimeout(() => {
          el.style.pointerEvents = "auto";
        }, binding.value || 2000);
      }
    });
  },
});

Object.keys(filters).forEach(function(key) {
  Vue.filter(key, filters[key]);
});

export default Vue;



// WEBPACK FOOTER //
// ./src/pages/index.js